import { apiBase } from "./base";

const apiSandbox = {
	client: apiBase.get_client(),
	url: "/",

	postSourceGgeSearchTask({ body }) {
		return this.client.post(this.url + "smetdocs/source_gge_search/", body, apiBase.get_headers());
	},

	downloadSourceGgeSearchResult({ taskId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "smetdocs/source_gge_search/result/" + taskId + "/", headers);
	},
};

export default apiSandbox;
